export enum IVerificaIdentitaPageTypes {
  AMDOCS = 'amdocs',
  NEW_ROAMING = 'new_roaming',
}
